// extracted by mini-css-extract-plugin
module.exports = {"generalPageContent":"general-page-content-module--general-page-content--2CU2A"};